import React from "react"
import styled from "styled-components"

import Link from "../animatedLink"
import navData from "./navData"

export default ({ children, animationState }) => {
  const links = navData().map(item => (
    <TopMenuListItem key={item.to}>
      {!item.isSubMenu ? (
        <TopMenuLink to={item.to}>{item.label}</TopMenuLink>
      ) : (
        <>
          <TopMenuButton>{item.label}</TopMenuButton>
          <SubMenu>
            {item.subMenu.map(subItem => (
              <SubMenuListItem key={subItem.to}>
                <SubMenuLink to={`${item.to}${subItem.to}`}>
                  <SubMenuLabel>{subItem.label}</SubMenuLabel>
                  <SubMenuDescription>{subItem.description}</SubMenuDescription>
                </SubMenuLink>
              </SubMenuListItem>
            ))}
          </SubMenu>
        </>
      )}
    </TopMenuListItem>
  ))

  return (
    <>
      <Nav className={`state-${animationState}`}>
        <TopMenu>{links}</TopMenu>
      </Nav>
    </>
  )
}

const Nav = styled.nav`
  position: absolute;
  z-index: 100;
  top: 5rem;
  left: 50%;
  width: 100%;
  max-width: ${({ theme }) => `${theme.maxWidth}px`};
  transform: translateX(-50%);
  background: ${({ theme }) => theme.colors.accent};
  font-weight: 100;
  font-size: 1.5rem;
  line-height: 1;

  &.state-entering {
    opacity: 0;
    transform: translateX(-50%) translateY(calc((5rem + 100%) * -1));
  }

  &.state-entered {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
    transition: opacity 0.25s 0.25s ease-in-out,
      transform 0.5s cubic-bezier(1, 0, 0, 1);
  }

  &.state-exiting {
    opacity: 0;
    transform: translateX(-50%) translateY(calc((5rem + 100%) * -1));
    transition: opacity 0.25s ease-in-out,
      transform 0.5s cubic-bezier(1, 0, 0, 1);
  }

  &::before {
    content: "";
    display: block;
    width: calc((100vw - ${({ theme }) => `${theme.maxWidth}px`}) / 2);
    height: 100%;
    background: ${({ theme }) => theme.colors.accent};
    position: absolute;
    left: 100%;
    top: 0;
  }
`

const TopMenu = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin: 0;
`

const SubMenu = styled(TopMenu)`
  position: absolute;
  top: 100%;
  left: 0;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: ${({ theme }) => theme.maxWidth}px;
  max-width: 100vw;
  margin: 0;
  background-color: ${({ theme }) => theme.colors.wash};
  background-image: linear-gradient(
    to right,
    transparent calc(100% / 3),
    ${({ theme }) => theme.colors.main} calc(100% / 3),
    ${({ theme }) => theme.colors.main} calc((100% / 3) + 1px),
    transparent calc((100% / 3) + 1px),
    transparent calc(100% / 3 * 2),
    ${({ theme }) => theme.colors.main} calc(100% / 3 * 2),
    ${({ theme }) => theme.colors.main} calc((100% / 3 * 2) + 1px),
    transparent calc((100% / 3 * 2) + 1px)
  );

  max-height: 0;
  transition: max-height 0.25s;
  overflow: hidden;

  li:hover & {
    max-height: 500px;
    transition: max-height 0.25s 0.25s;
  }
`

const TopMenuListItem = styled.li``

const SubMenuListItem = styled.li`
  width: calc(100% / 3);
  display: flex;
  justify-content: center;
  align-items: stretch;
  border-bottom: 1px solid ${({ theme }) => theme.colors.main};
`

const TopMenuLink = styled(Link)`
  display: inline-block;
  padding: 1.25rem 1rem;
  background: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.main};
  text-decoration: none;
  transition: background 0.25s, color 0.25s;

  li:hover &,
  &:hover {
    background: ${({ theme }) => theme.colors.wash};
    color: ${({ theme }) => theme.colors.accent};
  }
`

const TopMenuButton = styled.button`
  display: inline-block;
  padding: 1.25rem 1rem;
  border: 0;
  background: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.main};
  text-decoration: none;
  transition: background 0.25s, color 0.25s;
  cursor: pointer;

  li:hover &,
  &:hover {
    background: ${({ theme }) => theme.colors.wash};
    color: ${({ theme }) => theme.colors.accent};
  }
`

const SubMenuLink = styled(Link)`
  width: 100%;
  padding: 1rem;
  background: transparent;
  color: ${({ theme }) => theme.colors.contrast};
  text-decoration: none;

  &:hover {
    background: ${({ theme }) => theme.colors.main};
    color: ${({ theme }) => theme.colors.contrast};
  }
`
const SubMenuLabel = styled.span`
  display: block;
  margin: 0 0 0.5rem 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.accent};
`
const SubMenuDescription = styled.span`
  display: block;
  font-size: 0.75rem;
  font-weight: 200;
  line-height: 1.5;
`

// const Nav = styled.nav`
//   li {
//     ul {
// max-height: 0;
// transition: max-height 0.25s;
// overflow: hidden;
//     }

//     &:hover {
//       ul {
// max-height: 500px;
// transition: max-height 0.25s 0.25s;
//       }
//     }
//   }

//   a {
//   }

//   li:hover > a,
//   a:hover {
//
//   }
// `
